import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggleText", "toggleIcon"]
  static values = {
    showText: String,
    hideText: String
  }

  connect() {
    // Initialize with filters visible by default
    this.contentTarget.classList.remove('hidden')
    this.toggleTextTarget.textContent = this.hideTextValue
    this.toggleIconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />'
  }

  toggle() {
    if (this.contentTarget.classList.contains('hidden')) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.contentTarget.classList.remove('hidden')
    this.toggleTextTarget.textContent = this.hideTextValue
    this.toggleIconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />'
  }

  hide() {
    this.contentTarget.classList.add('hidden')
    this.toggleTextTarget.textContent = this.showTextValue
    this.toggleIconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />'
  }
} 